import React from 'react';
import styles from './participantsOverview.module.css';

const ParticipantOverview = ({ participants }) => {
    if (participants.length == 0) {
        return <></>
    }
    const shirtSizes = {};
    const eatingHabitList = [];
    const allergiesList = [];
    const sicknessList = [];

    participants.forEach(p => {
        // Count shirt sizes
        if (p.shirt) {
            shirtSizes[p.shirt] = (shirtSizes[p.shirt] || 0) + 1;
        }

        // Eating habits
        if (p.eatingHabit?.trim()) {
            eatingHabitList.push({
                name: `${p.vornameKind} ${p.nachnameKind}`,
                value: p.eatingHabit
            });
        }

        // Allergies
        if (p.allergies?.trim()) {
            allergiesList.push({
                name: `${p.vornameKind} ${p.nachnameKind}`,
                value: p.allergies
            });
        }

        // Sicknesses
        if (p.sickness?.trim()) {
            sicknessList.push({
                name: `${p.vornameKind} ${p.nachnameKind}`,
                value: p.sickness
            });
        }
    });

    return (
        <div className={styles.overviewContainer}>
            <h2>Übersicht: Teilnehmer*innen</h2>

            <div className={styles.overviewBlock}>
                <h3>👕 Shirtgrößen</h3>
                <ul>
                    {Object.entries(shirtSizes).map(([size, count]) => (
                        <li key={size}><strong>{size}</strong>: {count}</li>
                    ))}
                </ul>
            </div>

            {eatingHabitList.length > 0 && (
                <div className={styles.overviewBlock}>
                    <h3>🥦 Essgewohnheiten</h3>
                    <ul>
                        {eatingHabitList.map((e, idx) => (
                            <li key={idx}><strong>{e.name}</strong>: {e.value}</li>
                        ))}
                    </ul>
                </div>
            )}

            {allergiesList.length > 0 && (
                <div className={styles.overviewBlock}>
                    <h3>⚠️ Allergien</h3>
                    <ul>
                        {allergiesList.map((a, idx) => (
                            <li key={idx}><strong>{a.name}</strong>: {a.value}</li>
                        ))}
                    </ul>
                </div>
            )}

            {sicknessList.length > 0 && (
                <div className={styles.overviewBlock}>
                    <h3>🩺 Krankheiten</h3>
                    <ul>
                        {sicknessList.map((s, idx) => (
                            <li key={idx}><strong>{s.name}</strong>: {s.value}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ParticipantOverview;
